export const log = (text='', data) => {
    console.log(text, data)
}
